<template>
  <div>
    <v-data-table
      show-expand
      :headers="headers"
      :items="cotacoes.content"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="cotacoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma cotação encontrada"
      loading-text="Carregando cotações..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        <div class="text-center">
          <px-span-tooltip bottom :text="item.id" tooltip="Cotação Proxpect"/>
        </div>
      </template>
      <template v-slot:item.identificador="{ item }">
        <px-lista-cotacao-identificador :cotacao="item" @update="emitUpdate"/>
      </template>
      <template v-slot:item.comprador.nome="{ item }">
        <px-span-tooltip top :text="comprador(item)" :tooltip="item.comprador.pessoa.nome"/>
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{ item.createdIn | date(true) }}
      </template>
      <template v-slot:item.quantidadeProdutos="{ item }">
        {{ item.quantidadeProdutos }} produto(s)
      </template>
      <template v-slot:item.quantidadeRespostas="{ item }">
        {{ item.quantidadeRespostas }}/{{ item.quantidadeFornecedores }} resposta(s)
      </template>
      <template v-slot:item.prazoEntrega="{ item }">
        {{ item.prazoEntrega | date | naoInformado }}
      </template>
      <template v-slot:item.options="{ item }">
        <div class="text-right">
          <v-btn v-if="!isRascunho(item)" icon link :to="`cotacao/${item.id}/respostas`">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <px-lista-cotacao-options v-if="hasRoleComprador"
                                    :cotacao="item"
                                    @update="emitUpdate"
                                    @remove="onRemove"/>
        </div>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <px-lista-cotacao-produtos :cotacao="item"/>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { SituacaoCotacao } from 'px-business-components';
import ListaCotacaoIdentificador from './ListaCotacaoIdentificador.vue';
import ListaCotacaoOptions from './ListaCotacaoOptions.vue';
import ListaCotacaoProdutos from './ListaCotacaoProdutos.vue';

export default {
  props: {
    cotacoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Identificador',
          value: 'identificador',
        },
        {
          text: 'Empresa',
          value: 'comprador.nome',
        },
        {
          text: 'Data de entrada',
          value: 'createdIn',
        },
        {
          text: 'Produtos',
          sortable: false,
          value: 'quantidadeProdutos',
        },
        {
          text: 'Respostas',
          sortable: false,
          value: 'quantidadeRespostas',
        },
        {
          text: 'Prazo de entrega',
          value: 'prazoEntrega',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    comprador() {
      return item => Vue.filter('truncate')(item.comprador.pessoa.nome, 15);
    },
    isRascunho() {
      return item => SituacaoCotacao.keys.RASCUNHO.key === item.situacao;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
    onRemove(item) {
      this.$emit('remove', item);
    },
  },
  components: {
    pxListaCotacaoIdentificador: ListaCotacaoIdentificador,
    pxListaCotacaoOptions: ListaCotacaoOptions,
    pxListaCotacaoProdutos: ListaCotacaoProdutos,
  },
};
</script>
